/**
 * ETERNITY INTELLIGENCE — GLOBAL LAYOUT WRAPPER
 * Atmospheric background + navigation + content area
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import AtmosphericBackground from './AtmosphericBackground';
import BottomNav from './BottomNav';
import DesktopNav from './DesktopNav';

const IntelligenceLayout = () => {
  return (
    <div className="relative min-h-screen" style={{ background: '#000000' }}>
      {/* Atmospheric Background */}
      <AtmosphericBackground intensity="normal" />

      {/* Desktop Navigation */}
      <DesktopNav />

      {/* Main Content Area */}
      <main
        className="relative z-10 min-h-screen md:pb-0"
        style={{
          marginLeft: '0',
          paddingBottom: 'calc(72px + env(safe-area-inset-bottom))'
        }}
      >
        <div className="md:ml-20">
          <Outlet />
        </div>
      </main>

      {/* Mobile Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default IntelligenceLayout;